import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'oxyrion-ui/lib';
import baseTheme from 'oxyrion-ui/lib/Themes/baseTheme';
import { rem } from 'polished';
import styled from 'styled-components';
import { connect } from '../../Store';
import { ResponsiveTabs } from '../ReusableComponents';

const Wrapper = styled(ResponsiveTabs)`
  font-size: 12px;
  font-weight: 500;
  color: #6b6b68;
  margin-bottom: ${rem(20)};
  margin-right: 0;
  margin-right: ${rem(20)};
  margin-bottom: ${rem(20)};
  background: ${props => (props.background ? props.background : 'unset')};
`;

const IconWrapper = styled.div`
  height: 100%;
  width: ${rem(50)};
  padding-left: ${rem(8)};
  padding-top: ${rem(6)};
`;

const ContentWrapper = styled.div`
  width: 100%;
`;

const Header = styled.div`
  width: 100%;
  font-weight: 300;
  font-size: ${rem(28)};
  margin-bottom: ${rem(20)};
`;

const Content = styled.div``;

class BoxWithLabel extends React.Component {
  render() {
    const { icon, header, component, background } = this.props;

    return (
      <Wrapper background={background}>
        {icon && (
          <IconWrapper>
            <Icon name={icon} color={baseTheme.color.primary} size="xl" />
          </IconWrapper>
        )}
        <ContentWrapper>
          <Header>{header}</Header>
          <Content>{component}</Content>
        </ContentWrapper>
      </Wrapper>
    );
  }
}

BoxWithLabel.propTypes = {
  icon: PropTypes.string,
  header: PropTypes.string,
  background: PropTypes.string,
  component: PropTypes.node,
};

BoxWithLabel.defaultProps = {
  icon: null,
  header: '',
  background: null,
  component: <div />,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(BoxWithLabel);



// WEBPACK FOOTER //
// ./src/Components/BoxWithLabel/index.jsx